export default __webpack_public_path__ + "static/media/open-standard-cocoon.6b907fb6.mp4";